export enum ContentType {
  Article = 0,
  Gallery = 1,
  Page = 2,
  NewsBrief = 3,
  DigitalPublication = 4,
  SingleSponsor = 5,
  ContentSet = 6,
}

export function GetContentTypes(): string[] {
  return [
    'Article',
    'Gallery',
    'Page',
    'News Brief',
    'Digital Publication',
    'Single Sponsor',
    'Content Set',
  ];
}
